import React from 'react';
import { Box } from '../../../third-party-components/material-ui';

const AssessmentBody = ({children, style}) => (
    <div className="assessment-body" style={style}>{children}</div>
)

export default AssessmentBody;